import React, { useState } from "react";
import { motion } from "framer-motion";

const examples = {
  structures: [
    {
      name: "Person Struct",
      code: `type Person struct {
  Name string
  Age  int
}

// Инициализация:
p := Person{Name: "Иван", Age: 30}`,
      run: () => `p.Name = Иван, p.Age = 30`
    },
    {
      name: "Car Struct",
      code: `type Car struct {
  Brand string
  Year  int
}

// Инициализация:
c := Car{Brand: "Toyota", Year: 2021}`,
      run: () => `c.Brand = Toyota, c.Year = 2021`
    }
  ],
  methods: [
    {
      name: "Person.greet",
      code: `func (p Person) greet() string {
  return fmt.Sprintf("Привет, меня зовут %s и мне %d лет.", p.Name, p.Age)
}`,
      run: () => `Привет, меня зовут Иван и мне 30 лет.`
    }
  ],
  interfaces: [
    {
      name: "Animal Interface",
      code: `type Animal interface {
  Speak() string
}

type Dog struct{}
func (Dog) Speak() string {return "Woof!"}

type Cat struct{}
func (Cat) Speak() string {return "Meow!"}`,
      run: () => `Dog: Woof! | Cat: Meow!`
    }
  ],
  composition: [
    {
      name: "Person with Job",
      code: `type Job struct {Title string; StartYear int}

type Person struct {
  Name string
  Age  int
  Job  Job
}

// Инициализация:
job := Job{Title: "Программист", StartYear: 2020}
p := Person{Name: "Иван", Age: 30, Job: job}`,
      run: () => `p.Job.Title = Программист, p.Job.StartYear = 2020`
    }
  ]
};

const StructInterfaceDemo = () => {
  const categories = Object.keys(examples);
  const [category, setCategory] = useState(categories[0]);
  const [selected, setSelected] = useState(examples[category][0]);
  const [output, setOutput] = useState("");

  const handleCategory = (cat) => {
    setCategory(cat);
    setSelected(examples[cat][0]);
    setOutput("");
  };

  const handleRun = () => setOutput(selected.run());

  return (
    <div style={container}>
      <h3 style={header}>Интерактив: Структуры и Интерфейсы</h3>
      <div style={tabs}>
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => handleCategory(cat)}
            style={cat === category ? activeTab : tab}
          >{capitalize(cat)}</button>
        ))}
      </div>

      <div style={selector}>
        <label style={label}>Пример:</label>
        <select
          value={selected.name}
          onChange={e => {
            const ex = examples[category].find(x => x.name === e.target.value);
            setSelected(ex);
            setOutput("");
          }}
          style={select}
        >
          {examples[category].map(ex => (
            <option key={ex.name} value={ex.name}>{ex.name}</option>
          ))}
        </select>
      </div>

      <pre style={codeBlock}><code>{selected.code}</code></pre>

      <button style={runButton} onClick={handleRun}>Запустить</button>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: output ? 1 : 0 }}
        style={outputBox}
      >
        {output}
      </motion.div>
    </div>
  );
};

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const container = {
  maxWidth: '700px',
  margin: '2rem auto',
  padding: '1rem',
  background: '#fff',
  borderRadius: '1rem',
  border: '2px solid black',
};
const header = { textAlign: 'center', marginBottom: '1rem' };
const tabs = { display: 'flex', gap: '0.5rem', justifyContent: 'center', marginBottom: '1rem' };
const tab = { padding: '0.5rem 1rem', background: '#e0e0e0', border: 'none', borderRadius: '0.5rem', cursor: 'pointer' };
const activeTab = { ...tab, background: 'black', color: '#fff', fontFamily: 'Roboto, monospace'};
const selector = { display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' };
const label = { fontWeight: 'bold' };
const select = { padding: '0.4rem', border: '1px solid #ccc', borderRadius: '0.4rem' };
const codeBlock = { background: '#f5f5f5', padding: '1rem', borderRadius: '0.5rem', overflowX: 'auto' };
const runButton = { marginTop: '1rem', padding: '0.5rem 1rem', background: 'black', color: 'white', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontFamily: 'Roboto, monospace'};
const outputBox = { marginTop: '1rem', padding: '0.75rem', background: '#f5f5f5', borderRadius: '0.5rem', fontFamily: 'monospace', minHeight: '2rem' };

export default StructInterfaceDemo;